import { ServiceData } from '@/types';

import articles from './LOVE_ARTICLES_RO.json';
import audios from './LOVE_AUDIOS_RO.json';

export const LOVE_DATA_RO: ServiceData = {
  articles,
  audios,
};
